<template>
  <div>
    <button type="button" @click="notify">Show notification</button>
    <div v-for="baseData in pageData" :key="baseData.id">
      <div v-if="emptyDefaultValues(baseData)" class="mb-3">
        <component :is="baseData.type" :componentData="baseData" :mainData="mainData" />
      </div>
    </div>
  </div>
</template>

<script>
import Editable from '@/components/common/form/type/Editable.vue'
import CheckDocumets from '@/components/common/form/type/CheckDocuments.vue'
export default {
  components: {
    Editable,
    CheckDocumets,
  },
  data() {
    return {
      pageData: [
        {
          title: 'اطلاعات سفارش',
          type: 'Editable',
          id: 85,
          defaultValues: [
            {
              id: 100,
              value: [
                {
                  name: 'ec8f6708-2f74-4c3a-b55d-f62ee5b1f7a4.png',
                  type: 'image/png',
                  url: 'https://apg.cloudware.ir/filemanager/api/file/files/2b8a987a-7617-4784-2522-08d9b8bb52a0',
                },
                {
                  name: 'ec8f6708-2f74-4c3a-b55d-f62ee5b1f7a4.png',
                  type: 'image/png',
                  url: 'https://apg.cloudware.ir/filemanager/api/file/files/2b8a987a-7617-4784-2522-08d9b8bb52a0',
                },
                {
                  name: 'ec8f6708-2f74-4c3a-b55d-f62ee5b1f7a4.png',
                  type: 'image/png',
                  url: 'https://apg.cloudware.ir/filemanager/api/file/files/2b8a987a-7617-4784-2522-08d9b8bb52a0',
                },
              ],
            },
            { id: 99, value: '61-ص-195-99' },
            { id: 98, value: null },
            { id: 97, value: '#ff0000' },
            { id: 96, value: null },
            { id: 95, value: null },
            { id: 94, value: '3' },
            { id: 93, value: '1' },
            { id: 92, value: null },
            { id: 91, value: null },
            { id: 90, value: false },
            { id: 90, value: false },
            { id: 90, value: false },
          ],
          formData: [
            {
              title: '',
              sectionData: [
                {
                  cols: 1,
                  components: [
                    {
                      order: 0,
                      type: 'UploadBox',
                      id: 100,
                      attributes: {
                        componentData: [],
                        title: 'شبکه ها',
                        placeholder: 'شبکه ها',
                      },
                    },
                  ],
                },
                {
                  cols: 2,
                  components: [
                    {
                      order: 1,
                      type: 'Plaque',
                      id: 99,
                      attributes: {
                        componentData: null,
                        title: 'کد سفارش',
                        placeholder: 'کد سفارش',
                      },
                    },
                    {
                      order: 2,
                      type: 'BaseText',
                      id: '95',
                      attributes: {
                        inputType: 'number',
                        title: 'کد پستی',
                        placeholder: 'کد پستی',
                      },
                    },
                  ],
                },
                {
                  cols: 1,
                  components: [
                    {
                      order: 3,
                      type: 'TagComboBox',
                      id: 98,
                      relations: [
                        {
                          id: 98,
                          relationType: 'comboboxSearch',
                          api: '',
                          apiMethod: '',
                        },
                      ],
                      attributes: {
                        selectedValue: [],
                        searchedData: [],
                        componentData: [
                          { key: 1, value: 'orange' },
                          { key: 2, value: 'apple' },
                          { key: 3, value: 'pineapple' },
                          { key: 4, value: 'grape' },
                        ],
                        title: 'شبکه ها',
                        placeholder: 'شبکه ها',
                      },
                    },
                  ],
                },
                {
                  cols: 1,
                  components: [
                    {
                      order: 2,
                      type: 'ColorPicker',
                      id: 97,
                      attributes: {
                        inputType: 'text',
                        title: 'نام غرفه دار',
                        placeholder: 'نام غرفه دار',
                      },
                    },
                  ],
                },
                {
                  cols: 1,
                  components: [
                    {
                      order: 3,
                      type: 'ChooseImage',
                      id: 96,
                      attributes: {
                        defaultImage: '',
                        isUser: true,
                        cropperLoading: false,
                        imageCropperModal: false,
                        inputType: 'text',
                        title: 'آدرس خریدار',
                        placeholder: 'آدرس خریدار',
                      },
                    },
                  ],
                },
                {
                  cols: 1,
                  components: [
                    {
                      order: 4,
                      type: 'BaseText',
                      id: '95',
                      attributes: {
                        inputType: 'number',
                        title: 'کد پستی',
                        placeholder: 'کد پستی',
                      },
                    },
                  ],
                },
                {
                  cols: 2,
                  components: [
                    {
                      order: 5,
                      type: 'ComboBox',
                      id: 94,
                      relations: [
                        {
                          id: 93,
                          relationType: 'comboboxSelect',
                          api: 'http://dev.cloudware.ir:8888/Shipping/api/Address/GetCity',
                          apiMethod: 'get',
                        },
                        {
                          id: 94,
                          relationType: 'comboboxSearch',
                          api: '',
                          apiMethod: '',
                        },
                      ],
                      attributes: {
                        title: 'استان خریدار',
                        placeholder: 'استان خریدار',
                        searchedData: [],
                        componentData: [
                          {
                            key: 1,
                            value: 'آذربایجان شرقی',
                          },
                          {
                            key: 2,
                            value: 'آذربایجان غربی',
                          },
                          {
                            key: 3,
                            value: 'اردبیل',
                          },
                          {
                            key: 4,
                            value: 'اصفهان',
                          },
                          {
                            key: 5,
                            value: 'البرز',
                          },
                          {
                            key: 6,
                            value: 'ایلام',
                          },
                          {
                            key: 7,
                            value: 'بوشهر',
                          },
                          {
                            key: 8,
                            value: 'تهران',
                          },
                          {
                            key: 9,
                            value: 'چهارمحال و بختیاری',
                          },
                          {
                            key: 10,
                            value: 'خراسان جنوبی',
                          },
                          {
                            key: 11,
                            value: 'خراسان رضوی',
                          },
                          {
                            key: 12,
                            value: 'خراسان شمالی',
                          },
                          {
                            key: 13,
                            value: 'خوزستان',
                          },
                          {
                            key: 14,
                            value: 'زنجان',
                          },
                          {
                            key: 15,
                            value: 'سمنان',
                          },
                          {
                            key: 16,
                            value: 'سیستان و بلوچستان',
                          },
                          {
                            key: 17,
                            value: 'فارس',
                          },
                          {
                            key: 18,
                            value: 'قزوین',
                          },
                          {
                            key: 19,
                            value: 'قم',
                          },
                          {
                            key: 20,
                            value: 'كردستان',
                          },
                          {
                            key: 21,
                            value: 'كرمان',
                          },
                          {
                            key: 22,
                            value: 'كرمانشاه',
                          },
                          {
                            key: 23,
                            value: 'کهگیلویه و بویراحمد',
                          },
                          {
                            key: 24,
                            value: 'گلستان',
                          },
                          {
                            key: 25,
                            value: 'گیلان',
                          },
                          {
                            key: 26,
                            value: 'لرستان',
                          },
                          {
                            key: 27,
                            value: 'مازندران',
                          },
                          {
                            key: 28,
                            value: 'مركزی',
                          },
                          {
                            key: 29,
                            value: 'هرمزگان',
                          },
                          {
                            key: 30,
                            value: 'همدان',
                          },
                          {
                            key: 31,
                            value: 'یزد',
                          },
                        ],
                        selectedValue: '',
                      },
                    },
                    {
                      order: 6,
                      type: 'ComboBox',
                      id: 93,
                      relations: [
                        {
                          id: 93,
                          relationType: 'comboboxSearch',
                          api: '',
                          apiMethod: '',
                        },
                      ],
                      attributes: {
                        title: 'شهر خریدار',
                        placeholder: 'شهر خریدار',
                        componentData: [
                          {
                            key: 1,
                            value: 'آذربایجان شرقی',
                          },
                          {
                            key: 2,
                            value: 'آذربایجان غربی',
                          },
                          {
                            key: 3,
                            value: 'اردبیل',
                          },
                        ],
                        searchedData: [],
                        selectedValue: '',
                      },
                    },
                  ],
                },
                {
                  cols: 2,
                  components: [
                    {
                      order: 7,
                      type: 'BaseText',
                      id: 92,
                      attributes: {
                        inputType: 'number',
                        title: 'تلفن خریدار',
                        placeholder: 'تلفن خریدار',
                      },
                    },
                    {
                      order: 8,
                      type: 'BaseText',
                      id: 91,
                      attributes: {
                        inputType: 'number',
                        title: 'شماره همراه خریدار',
                        placeholder: 'شماره همراه خریدار',
                      },
                    },
                  ],
                },
                {
                  cols: 1,
                  components: [
                    {
                      order: 9,
                      type: 'Checkbox',
                      id: 90,
                      attributes: {
                        title: 'کد پستی',
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: 'اطلاعات سفارش',
          type: 'CheckDocumets',
          video: 'https://www.w3schools.com/html/mov_bbb.mp4',
          image:
            'https://static3.mojnews.com/thumbnail/tBc8tpVN9DEx/b3KyLJtobNa7mxZapfED8JOntVHTpFuUbWspqcFByNkcHNRUCrFsz0kM90mnzV49H9KandiKg2ugPzrLJCrgIhQWx9ufaDpmYsHoagkScps,/%DA%A9%D8%A7%D8%B1%D8%AA+%D9%85%D9%84%DB%8C+%D9%87%D9%88%D8%B4%D9%85%D9%86%D8%AF.jpg',
          imageTitle: 'تصویر کارت ملی',
          imageSize: '37 mb',
          videoTitle: 'ویدئو تستی',
          videoSize: '180 mb',
        },
      ],
      notification: {
        title: 'Your title',
        options: {
          body: 'This is an example!',
        },
      },
    }
  },
  methods: {
    notify() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification#Parameters
      const notification = {
        title: 'Your title',
        options: {
          body: 'This is an example!',
        },
        events: {
          onerror: function () {
            console.log('Custom error event was called')
          },
          onclick: function () {
            console.log('Custom click event was called')
          },
          onclose: function () {
            console.log('Custom close event was called')
          },
          onshow: function () {
            console.log('Custom show event was called')
          },
        },
      }
      this.$notification.show(notification.title, notification.options, notification.events)
    },
    emptyDefaultValues(baseData) {
      if (baseData.type == 'Editable')
        if (!baseData.defaultValues) {
          return false
        } else {
          return true
        }
      else {
        return true
      }
    },
  },
}
</script>

<style></style>
